import React from 'react';
import styles from './ReopenReasonPopup.module.scss';
import PropTypes from 'prop-types';

import DialogWrapper from 'components/DialogComponents/DialogWrapper';
import DialogHeader from 'components/DialogComponents/DialogHeader';
import { MainButton } from 'components/StyledComponents';
import FormInputText from 'components/FormComponents/FormInputText/FormInputText_v2';

import { useForm, FormProvider } from 'react-hook-form';

function ReopenReasonPopup({ open, setOpen, onSubmitData }) {
  const methods = useForm({
    defaultValues: {
      reason: ''
    }
  });

  const { handleSubmit, watch } = methods;

  const inputValue = watch('reason');

  const onSubmit = (data) => {
    const reasonText = data.reason;
    onSubmitData(reasonText);
    setOpen(false);
  };

  const closePopup = () => {
    setOpen(false);
  };

  return (
    <DialogWrapper open={open} onClose={closePopup}>
      <div className={styles.reopenReasonPopupContainer}>
        <div className={styles.reopenReasonPopup}>
          <DialogHeader title="Reason for Reopen" onClose={closePopup} />
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormInputText
                name="reason"
                options={{
                  type: 'text',
                  full: true
                }}
                className={styles.reopenInput}
              />
            </form>
            <div className={styles.buttonsWrapper}>
              <MainButton text="Cancel" action={closePopup} type="secondary" />
              <MainButton
                text="Submit"
                action={handleSubmit(onSubmit)}
                type="primary"
                isDisabled={!inputValue?.trim()}
              />
            </div>
          </FormProvider>
        </div>
      </div>
    </DialogWrapper>
  );
}

ReopenReasonPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
};

export default ReopenReasonPopup;
